import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{attrs:{"id":"attendance-list"}},[_c(VBtn,{staticStyle:{"margin-left":"10px"},attrs:{"type":"button","color":"primary","text":""},on:{"click":function($event){return _vm.goBack()}}},[_vm._v("\n    Voltar\n  ")]),_vm._l((_vm.tabs),function(tab){return _c(VCard,{key:tab.id,staticClass:"rounded-0 bg-light inside"},[(_vm.tabName === tab.id)?_c('div',{staticClass:"mb-6"},[_c(_vm.dinamicyComponent(tab.component),{tag:"component"})],1):_vm._e()])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }